module.exports = __webpack_public_path__ + "static/media/emo2b.60726c45.png";